export const environment = {
  production: true,
  API: "https://api.monto.mx",
  COOKIE: {
    DASHBOARD: "prod-monto-session-dashboard",
    CURRENT_USER_COOKIE: "prod-monto-session-cookie",
    CURRENT_USER_COMPANY: "prod-monto-company-cookie",
  },
};
